module.exports = __webpack_public_path__ + "0cfad8942790169fef3fb535a4c0921e.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-accounts/info-sharing-accounts-de.html
// module id = 1033
// module chunks = 0